<template>
  <div class="orderContainer" v-sound>
    <h2 class="orderTitle">お会計の確認</h2>
    <hr class="titleLine" />

    <div class="orderList">
      <table class="orderTable">
        <thead>
          <tr>
            <th>商品名</th>
            <th>数量</th>
            <th>提供状況</th>
            <th>小計</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in displayOrders" :key="order.id">
            <td><p v-html="order.label"></p></td>
            <td>{{ order.quantity }}</td>
            <td>
              <span v-if="order.status === 0"></span>
              <span v-else-if="order.status === 1" class="status-served">済</span>
              <span v-else></span>
            </td>
            <td>
              {{ Math.round(order.quantity * order.price / 1.1).toLocaleString() }}円<br>
              <span class="tax-included-price">
                (税込{{ (order.quantity * order.price).toLocaleString() }}円)
              </span>
            </td>
          </tr>
          <tr v-for="index in Math.max(8 - orderitemsDB.length, 0)" :key="'empty-' + index">
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4" class="totalRow">
              <span class="totalLabel">合計</span>
              <span class="totalAmount">
                {{ Math.round(totalAmount / 1.1).toLocaleString() }}円
                <span class="tax-included-price">
                  (税込{{ totalAmount.toLocaleString() }}円)
                </span>
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="buttonContainer">
      <button class="backButton" @click="goToMenu">戻る</button>
      <button class="confirmButton" @click="showConfirm('checkout')"
        :disabled="this.totalAmount === 0">お会計を確定する</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      orderitems: [],
      tablesessions: [],
      orderitemsDB: [],
      otherMenu: [],
      totalAmount: 0,
      diningTableID: localStorage.getItem('diningTableID'),
    };
  },
  created() {
    this.axios({
      method: 'GET',
      url: '/v1/connection/test',
    })
      .then((response) => {
        console.log(response.data.status);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
    this.getOrderItems();
    this.getTableSessions();
  },
  computed: {
    ...mapState(['user', 'cart', 'helper']),
    orderHistoryItems() {
      return this.$store.state.orderhistory.items;
    },
    displayOrders() {
      if (!this.orderitems || this.orderitems.length === 0) {
        return [];
      }

      return this.orderitems.map((item, index) => {
        const status = this.orderitemsDB[index] ? this.orderitemsDB[index].status : 0;
        return {
          ...item,
          status,
        };
      });
    },
  },
  watch: {
    orderHistoryItems: {
      handler(newItems) {
        this.orderitems = JSON.parse(JSON.stringify(newItems || []));
        this.calculateTotalAmount();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    calculateTotalAmount() {
      this.totalAmount = this.orderitems
        .filter((item) => item.flag !== 998 && item.flag !== 999)
        .reduce((sum, item) => sum + item.quantity * item.price, 0);
    },
    goToMenu() {
      if (window.innerWidth <= 768) {
        this.$router.push('/menu-mobile');
      } else {
        this.$router.push('/menu');
      }
    },
    getTableSessions() {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'GET',
          url: '/v1/tablesession/get/list',
          params: {
            activeTableId: this.diningTableID,
            user_id: this.user.id,
          },
        })
          .then((response) => {
            this.tablesessions = response.data.list.data;
            resolve();
          })
          .catch((error) => {
            if (error.response) console.log(error.response);
            else console.log(error);
            reject(error);
          });
      });
    },
    getMenus() {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'GET',
          url: 'v1/menu/get/list',
          params: {
            user_id: this.user.id,
          },
        })
          .then((response) => {
            const res = response.data;
            const list = Array.isArray(res?.list?.data) ? res.list.data : [];
            this.otherMenu = list
              .filter((menu) => Number(menu?.flag) === 2)
              .map((m) => ({ ...m }));
            console.log('otherMenu (plain):', this.otherMenu);
            resolve();
          })
          .catch((error) => {
            if (error.response) console.log(error.response);
            else console.log(error);
            reject(error);
          });
      });
    },

    async getOrderItems() {
      await this.getTableSessions();
      await this.getMenus();

      const excludedIds = (this.otherMenu || []).map((m) => m.id).filter(Boolean);
      console.log('excludedIds:', excludedIds);

      const excludeParam = excludedIds.length ? { excludeMenu: excludedIds } : {};

      this.axios({
        method: 'GET',
        url: '/v1/orderitem/get/list',
        params: {
          ...excludeParam,
          includeSession: [this.tablesessions[0]?.id],
          includeTable: this.diningTableID,
          user_id: this.user.id,
        },
      })
        .then((response) => {
          this.orderitemsDB = response.data.list.data;
          console.log('orderitemsDB:', this.orderitemsDB);
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    showConfirm(type) {
      const data = {
        diningTableID: this.diningTableID,
        tableSessionID: this.tablesessions[0]?.id,
        type,
      };
      const args = {
        modalName: 'Confirm',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
  },
};
</script>

<style scoped>
/* ✅ 背景設定（画面全体） */
.orderContainer {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10vw;
  /* 上下の余白 */
  padding-top: 5vh;
  padding-bottom: 5vh;
  position: relative;
}

/* ✅ タイトル */
.orderTitle {
  font-family: 'HGS明朝B', serif;
  font-size: 50px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

/* ✅ タイトル下の線 */
.titleLine {
  width: 90%;
  border: 3px solid #333;
  margin-bottom: 20px;
}

/* ✅ 注文リスト（スクロール対応） */
.orderList {
  width: 90%;
  height: 60vh;
  overflow-y: auto;
  border: 3px solid #333;
}

/* ✅ テーブル全体設定 */
.orderTable {
  width: 100%;
  font-family: '游明朝', serif;
  color: #333;
  background-color: transparent;
}

/* ✅ テーブルヘッダー */
.orderTable th {
  font-size: 2vw;
  font-weight: bold;
  background-color: transparent;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
  position: sticky;
  top: 0;
  background-image: url('/img/menu/paperboard-texture.jpg');
  white-space: nowrap;
}

/* ✅ テーブルセル（透明化） */
.orderTable td {
  font-size: 2vw;
  font-weight: normal;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
  height: 50px;
  background-color: transparent;
  white-space: pre-wrap;
  line-height: 1.2;
}

.status-served {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 3.5vw;
  height: 3.5vw;
  min-width: 40px;
  min-height: 40px;
  color: #D32F2F;
  border: 3px solid #D32F2F;
  border-radius: 50%;
  font-size: 2vw;
  font-weight: bold;
}

.tax-included-price {
  font-size: 0.8em;
}

.orderTable th:nth-child(1),
.orderTable td:nth-child(1) {
  width: 45%;
}

.orderTable th:nth-child(2),
.orderTable td:nth-child(2) {
  width: 10%;
}

.orderTable th:nth-child(3),
.orderTable td:nth-child(3) {
  width: 15%;
}

.orderTable th:nth-child(4),
.orderTable td:nth-child(4) {
  width: 30%;
}

/* ✅ テーブルフッター（固定） */
.orderTable tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  border: 3px solid #333;
  background-image: url('/img/menu/paperboard-texture.jpg');
}

.orderTable tfoot td {
  font-size: 2vw;
  font-weight: bold;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
}


/* ✅ ボタンコンテナ */
.buttonContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 25px;
}

/* ✅ 戻るボタン */
.backButton {
  background-color: transparent;
  color: #333;
  font-family: '游明朝', serif;
  font-size: 2vw;
  padding: 2vh 5vw;
  border: 2px solid #333;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.backButton:hover {
  background-color: #EDEDED;
}

/* ✅ お会計を確定するボタン */
.confirmButton {
  background-color: #953127;
  color: #FFFFFF;
  font-family: 'HGS明朝B', serif;
  font-size: 2vw;
  padding: 2vh 5vw;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.confirmButton:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

@media (max-width: 768px) {
  .orderContainer {
    padding: 5vh 5vw; /* 上下の余白は維持し、左右の余白を減らす */
  }

  .titleLine,
  .orderList {
    width: 100%; /* 親要素いっぱいに広げる */
  }

  .orderTitle {
    font-size: 36px; /* モバイルでのタイトルフォントサイズを小さく */
  }

  .orderTable th,
  .orderTable td,
  .orderTable tfoot td {
    font-size: 1.1rem; /* モバイルでのテーブル内テキストを大きく */
  }

  .backButton,
  .confirmButton {
    font-size: 1.2rem; /* モバイルでのボタンテキストを大きく */
    padding: 1.5vh 4vw; /* ボタンのパディングを調整 */
  }
  
  .status-served {
    font-size: 1.1rem; /* モバイルでの提供状況テキスト */
    width: 30px;
    height: 30px;
    min-width: unset;
    min-height: unset;
  }
}
</style>
